import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';


const AffiliateTime = function AffiliateTime(props) {
  let timeAge;
  const {
    time,
    affiliateTimeZone,
    mask,
  } = props;

  const convertTime = () => {
    let affTime;
    if (affiliateTimeZone.length > 0) {
      affTime = moment(time).tz(affiliateTimeZone);
    } else {
      affTime = moment(time).format(mask);
    }

    if (mask && moment(time).isValid()) {
      affTime = affTime.format(mask);
    } else if (!moment(time).isValid()) {
      affTime = '';
    }

    return affTime;
  };

  if (affiliateTimeZone) {
    timeAge = convertTime();
  }
  return (<span> {timeAge} </span>);
};

AffiliateTime.propTypes = {
  time: PropTypes.string,
  mask: PropTypes.string,
  affiliateTimeZone: PropTypes.string,
};


const mapStateToProps = ({ session: { affiliate } }) => ({
  affiliateTimeZone: affiliate.attributes.timezone,
});

export default connect(mapStateToProps)(AffiliateTime);



// WEBPACK FOOTER //
// ./src/components/Filters/AffiliateTime.js